var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.9999V17.0099M13 16.9999V17.0099M15 12.9999V10.9999M11.75 8.74988C12.1203 8.23373 12.6083 7.8132 13.1734 7.52312C13.7386 7.23303 14.3647 7.08173 15 7.08173C15.6353 7.08173 16.2614 7.23303 16.8266 7.52312C17.3917 7.8132 17.8797 8.23373 18.25 8.74988M8.5 6.49988C9.24067 5.46758 10.2166 4.62653 11.3469 4.04636C12.4772 3.46619 13.7295 3.16357 15 3.16357C16.2705 3.16357 17.5228 3.46619 18.6531 4.04636C19.7834 4.62653 20.7593 5.46758 21.5 6.49988M3 14.9999C3 14.4694 3.21071 13.9607 3.58579 13.5857C3.96086 13.2106 4.46957 12.9999 5 12.9999H19C19.5304 12.9999 20.0391 13.2106 20.4142 13.5857C20.7893 13.9607 21 14.4694 21 14.9999V18.9999C21 19.5303 20.7893 20.039 20.4142 20.4141C20.0391 20.7892 19.5304 20.9999 19 20.9999H5C4.46957 20.9999 3.96086 20.7892 3.58579 20.4141C3.21071 20.039 3 19.5303 3 18.9999V14.9999Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnime);
export default __webpack_public_path__ + "static/media/anime.aa5fc6f5415ad3f51e16788a0d58d025.svg";
export { ForwardRef as ReactComponent };